import React from 'react';

function AGB() {
  return (
    <main id="main-content" role="main">
      {/* Hero Section */}
      <section className="hero hero--small">
        <div className="container">
          <div className="hero__content">
            <div className="hero__text">
              <h1 className="hero__title">Allgemeine Geschäftsbedingungen</h1>
              <p className="hero__subtitle">
                Transparente Konditionen für unsere Social Recruiting Services
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* AGB Content */}
      <section className="legal-content">
        <div className="container">
          <div className="legal-wrapper">
            <div className="legal-section">
              <h2>1. Geltungsbereich</h2>
              <p>
                Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge, die zwischen der
                track by track GmbH (nachfolgend "famefact" oder "wir") und ihren Kunden (nachfolgend "Kunde"
                oder "Sie") über die Erbringung von Social Recruiting Services abgeschlossen werden.
              </p>
              <p>
                Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, famefact stimmt
                ihrer Geltung ausdrücklich schriftlich zu.
              </p>
            </div>

            <div className="legal-section">
              <h2>2. Leistungsbeschreibung</h2>
              <p>famefact bietet Social Recruiting Services an, insbesondere:</p>
              <ul>
                <li>Instagram Recruiting Kampagnen</li>
                <li>LinkedIn Recruiting und Executive Search</li>
                <li>TikTok Recruiting für Gen Z</li>
                <li>Social Media Strategieentwicklung</li>
                <li>Content Creation und Management</li>
                <li>Performance Tracking und Optimierung</li>
                <li>Beratung und Analyse</li>
              </ul>
              <p>Die genaue Leistungsbeschreibung ergibt sich aus dem jeweiligen Angebot oder Vertrag.</p>
            </div>

            <div className="legal-section">
              <h2>3. Vertragsschluss</h2>
              <p>
                Angebote von famefact sind freibleibend und unverbindlich. Ein Vertrag kommt erst durch
                schriftliche Auftragsbestätigung oder durch Beginn der Leistungserbringung zustande.
              </p>
              <p>Die kostenlose Erstberatung ist unverbindlich und stellt noch keinen Vertragsschluss dar.</p>
            </div>

            <div className="legal-section">
              <h2>4. Preise und Zahlungsbedingungen</h2>
              <p>
                Die Preise ergeben sich aus dem jeweiligen Angebot. Alle Preise verstehen sich zuzüglich
                der gesetzlichen Umsatzsteuer.
              </p>
              <p>
                Rechnungen sind innerhalb von 14 Tagen nach Rechnungsdatum ohne Abzug zahlbar, sofern
                nichts anderes vereinbart wurde.
              </p>
              <p>
                Bei Zahlungsverzug behält sich famefact vor, Mahngebühren in Höhe von 5,00 € pro Mahnung
                sowie Verzugszinsen in Höhe von 9% über dem jeweiligen Basiszinssatz zu verlangen.
              </p>
            </div>

            <div className="legal-section">
              <h2>5. Leistungserbringung</h2>
              <p>
                famefact erbringt die vereinbarten Leistungen nach bestem Wissen und Gewissen. Die
                Leistungserbringung erfolgt in der Regel innerhalb der vereinbarten Fristen.
              </p>
              <p>
                famefact behält sich vor, Leistungen durch qualifizierte Subunternehmer erbringen zu lassen,
                sofern dies die Qualität der Leistung nicht beeinträchtigt.
              </p>
              <p>
                Der Kunde verpflichtet sich, famefact alle für die Leistungserbringung erforderlichen
                Informationen und Materialien rechtzeitig zur Verfügung zu stellen.
              </p>
            </div>

            <div className="legal-section">
              <h2>6. Erfolgsbasiertes Recruiting</h2>
              <p>
                Bei erfolgsbasierten Recruiting-Kampagnen (Cost-per-Application Model) erfolgt die
                Abrechnung nur für tatsächlich generierte, qualifizierte Bewerbungen.
              </p>
              <p>
                Eine Bewerbung gilt als qualifiziert, wenn sie die im Angebot definierten Kriterien
                erfüllt (z.B. Vollständigkeit der Unterlagen, Relevanz der Qualifikation).
              </p>
              <p>
                Bei Nichteinhaltung der Qualitätskriterien durch famefact erfolgt eine kostenlose
                Nachbesserung oder Erstattung.
              </p>
            </div>

            <div className="legal-section">
              <h2>7. Haftung</h2>
              <p>
                famefact haftet für Vorsatz und grobe Fahrlässigkeit uneingeschränkt. Für einfache
                Fahrlässigkeit haftet famefact nur bei Verletzung wesentlicher Vertragspflichten
                (Kardinalpflichten) in Höhe des vertragstypischen, vorhersehbaren Schadens.
              </p>
              <p>
                Die Haftung für mittelbare Schäden, entgangenen Gewinn oder Datenverlust ist
                ausgeschlossen, es sei denn, es liegt Vorsatz oder grobe Fahrlässigkeit vor.
              </p>
              <p>Die Haftung nach dem Produkthaftungsgesetz bleibt unberührt.</p>
            </div>

            <div className="legal-section">
              <h2>8. Urheberrechtliche Nutzungsrechte / Leistungsschutzrechte</h2>
              <p>
                <strong>Sofern nicht abweichend vereinbart, erwirbt der Auftraggeber mit vollständiger Bezahlung 
                lediglich die für die vereinbarte Vertragslaufzeit erforderlichen, einfachen Nutzungsrechte an den 
                von der Agentur gestalteten Werbemitteln zur Nutzung in den im Vertrag bezeichneten Social-Media-Kanälen.</strong>
              </p>
              <p>
                Nach Ablauf der Vertragslaufzeit endet das Nutzungsrecht automatisch, es sei denn, die Parteien 
                vereinbaren schriftlich eine Verlängerung oder weitergehende Lizenz.
              </p>
              <p>
                Eine darüber hinausgehende Nutzung, insbesondere außerhalb der Vertragslaufzeit oder auf weiteren 
                Kanälen (z. B. Print, TV, Out-of-Home), bedarf der ausdrücklichen, schriftlichen Zustimmung der 
                Agentur und ist gesondert zu vergüten.
              </p>
            </div>

            <div className="legal-section">
              <h2>9. Werbeanzeigenmanager und Social-Media-Konten</h2>
              <p>
                Der Auftraggeber erteilt famefact Zugang zu den vereinbarten Werbekonten (z. B. Meta Business 
                Manager, LinkedIn Campaign Manager, TikTok Ads Manager).
              </p>
              <p>
                famefact kann im Rahmen der Leistungserbringung Inhalte posten und Kampagnen erstellen, hat 
                jedoch keinen Zugriff auf private Nachrichten, es sei denn, dies wird ausdrücklich gestattet.
              </p>
              <p>
                Ist die Unterscheidung zwischen von famefact oder vom Auftraggeber erstellten Anzeigen technisch 
                nicht möglich, liegt die Haftung für Budgetfehler beim Auftraggeber.
              </p>
            </div>

            <div className="legal-section">
              <h2>10. Besprechungsberichte</h2>
              <p>
                famefact erstellt innerhalb von drei Arbeitstagen nach jeder Besprechung einen Bericht. Dieser 
                gilt als verbindliche Arbeitsgrundlage, sofern der Auftraggeber nicht innerhalb von fünf 
                Arbeitstagen in Textform widerspricht.
              </p>
            </div>

            <div className="legal-section">
              <h2>11. Datenschutz</h2>
              <p>
                famefact verarbeitet personenbezogene Daten gemäß der geltenden Datenschutzgesetze,
                insbesondere der DSGVO. Details entnehmen Sie bitte unserer Datenschutzerklärung.
              </p>
            </div>

            <div className="legal-section">
              <h2>12. Vertraulichkeit</h2>
              <p>
                Beide Parteien verpflichten sich, alle im Rahmen der Zusammenarbeit bekannt gewordenen
                vertraulichen Informationen geheim zu halten und nicht an Dritte weiterzugeben.
              </p>
              <p>
                Diese Verpflichtung gilt auch nach Beendigung des Vertragsverhältnisses für einen
                Zeitraum von 2 Jahren.
              </p>
            </div>

            <div className="legal-section">
              <h2>13. Kündigung</h2>
              <p>
                Verträge mit fester Laufzeit enden automatisch zum vereinbarten Zeitpunkt. Eine
                vorzeitige Kündigung ist nur aus wichtigem Grund möglich.
              </p>
              <p>
                Bei erfolgsbasierten Kampagnen kann der Kunde jederzeit ohne Einhaltung einer Frist
                kündigen. Bereits erbrachte Leistungen werden anteilig abgerechnet.
              </p>
            </div>

            <div className="legal-section">
              <h2>14. Gewährleistung</h2>
              <p>
                famefact gewährleistet, dass die erbrachten Leistungen den vereinbarten Spezifikationen
                entsprechen. Bei Mängeln hat der Kunde Anspruch auf Nachbesserung.
              </p>
              <p>Die Gewährleistungsfrist beträgt 12 Monate ab Leistungserbringung.</p>
            </div>

            <div className="legal-section">
              <h2>15. Schlussbestimmungen</h2>
              <p>Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts.</p>
              <p>Gerichtsstand für alle Streitigkeiten ist Berlin, sofern der Kunde Kaufmann ist.</p>
              <p>
                Sollten einzelne Bestimmungen dieser AGB unwirksam sein oder werden, bleibt die
                Wirksamkeit der übrigen Bestimmungen unberührt.
              </p>
              <p>
                <strong>Stand: 15. Januar 2025</strong>
              </p>
            </div>

            <div className="legal-section">
              <h2>16. Kontakt</h2>
              <p>Bei Fragen zu diesen AGB oder zu unseren Services können Sie uns gerne kontaktieren:</p>
              <address>
                track by track GmbH<br />
                Schliemannstraße 23<br />
                10437 Berlin<br />
                Deutschland
              </address>
              <p>
                <strong>Telefon:</strong> <a href="tel:+4930403665430">030 403 665 430</a><br />
                <strong>E-Mail:</strong> <a href="mailto:info@famefact.com">info@famefact.com</a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default AGB;
